<template>
  <div>
    <h2><i>Youtube</i></h2>

    <div class="row">
      <div class="col-xs-12 col-md-8">
        <interview-video :issue="issue"></interview-video>
      </div>
      <div class="col-xs-12 col-md-4">
        <interview-video :issue="issue"></interview-video>
        <div class="mb-2"></div>
        <interview-video :issue="issue"></interview-video>
      </div>
    </div>
  </div>
</template>

<script>
  import InterviewVideo from '@/components/shared/InterviewVideoComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'media',
    components: {
      InterviewVideo
    },
    mixins: [ UtilityMixin ],
    data () {
      return {
        issues: {}
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-interact'}
      this.$parent.$parent.nextPage = false
      this.$parent.$parent.prevSlide = {name: 'article-media-facebook'}
      this.$parent.$parent.nextSlide = {name: 'article-media-linkedin'}

      this.issue = this.getStaticPath('mocks/video-list.json').videos[0]
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// MediaYoutubePage.vue?02209d83